module.exports = __webpack_public_path__ + "static/media/hall-CSB.3e262f98.svg";